import React from 'react';

interface SeeIconProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const SeeIcon: React.FC<SeeIconProps> = ({ 
  width = 24, 
  height = 24, 
  fill = '#161616',
  color,
  className,
  style 
}) => {
  const fillColor = color || fill;
  
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M12 5.40039C15.7858 5.40053 19.0394 8.00991 20.8359 9.7959C21.292 10.2493 21.6361 10.5783 21.8369 11.1934C21.9172 11.4394 21.9463 11.7376 21.9463 12C21.9463 12.2624 21.9172 12.5606 21.8369 12.8066C21.6361 13.4218 21.2919 13.7508 20.8359 14.2041C19.0394 15.9901 15.7858 18.5995 12 18.5996C8.21406 18.5996 4.95967 15.9902 3.16309 14.2041C2.70655 13.7502 2.36294 13.4219 2.16211 12.8066C2.08184 12.5606 2.05273 12.2624 2.05273 12C2.05274 11.7376 2.08184 11.4394 2.16211 11.1934C2.36293 10.5781 2.70652 10.2498 3.16309 9.7959C4.95967 8.00983 8.21406 5.40039 12 5.40039ZM12 6.59961C8.72481 6.59961 5.77209 8.89454 4.00977 10.6465C3.52725 11.1262 3.40088 11.2655 3.30273 11.5664C3.27643 11.6473 3.25195 11.806 3.25195 12C3.25195 12.194 3.27644 12.3527 3.30273 12.4336C3.40087 12.7344 3.52719 12.8738 4.00977 13.3535C5.77209 15.1055 8.72484 17.4004 12 17.4004C15.2751 17.4002 18.227 15.1054 19.9893 13.3535C20.4716 12.874 20.5982 12.7342 20.6963 12.4336C20.7226 12.3527 20.7471 12.194 20.7471 12C20.7471 11.806 20.7226 11.6473 20.6963 11.5664C20.5982 11.2658 20.4716 11.126 19.9893 10.6465C18.227 8.89454 15.2751 6.59975 12 6.59961ZM13.3994 12C13.3994 11.227 12.773 10.5999 12 10.5996C11.2268 10.5996 10.5996 11.2268 10.5996 12C10.5996 12.7732 11.2268 13.4004 12 13.4004C12.773 13.4001 13.3994 12.773 13.3994 12ZM14.5996 12C14.5996 13.4358 13.4357 14.5993 12 14.5996C10.5641 14.5996 9.39941 13.4359 9.39941 12C9.39941 10.5641 10.5641 9.40039 12 9.40039C13.4357 9.40065 14.5996 10.5642 14.5996 12Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default SeeIcon;


